var _regeneratorRuntime = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/createClass.js");

/*
  A library for getting information about a token, including its mutable and
  immutable data.

  Implements this specification for mutable data:
  https://github.com/Permissionless-Software-Foundation/specifications/blob/master/ps002-slp-mutable-data.md

*/
// Global npm libraries
var axios = require('axios');

var Get = /*#__PURE__*/function () {
  "use strict";

  function Get() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Get);

    // Dependency Injections
    this.wallet = localConfig.wallet;

    if (!this.wallet) {
      throw new Error('Instance of minimal-slp-wallet must be passed as wallet when instantiating get.js library.');
    } // cidUrlType has a value of 1 or 2:
    // 1 - The CID should go at the end, as a directory.
    // 2 - The CID should go at the beginning of the URL, as a subdomain.


    this.cidUrlType = 1;
    if (localConfig.cidUrlType) this.cidUrlType = localConfig.cidUrlType; // The Gateway URL is used to retrieve IPFS data.

    this.ipfsGatewayUrl = 'p2wdb-gateway-678.fullstack.cash'; // Type 1 CID URL.
    // this.ipfsGatewayUrl = 'ipfs.dweb.link/data.json' // Type 2 CID URL.

    if (localConfig.ipfsGatewayUrl) this.ipfsGatewayUrl = localConfig.ipfsGatewayUrl; // Encapsulate dependencies

    this.bchjs = this.wallet.bchjs;
    this.axios = axios; // Bind 'this' object to functions that lose context.

    this.data = this.data.bind(this);
    this.dataCids = this.dataCids.bind(this);
    this.tokenStats = this.tokenStats.bind(this);
    this.mutableCid = this.mutableCid.bind(this);
    this.decodeOpReturn = this.decodeOpReturn.bind(this);
    this.getCidData = this.getCidData.bind(this);
  } // Attempt to retrieve mutable and immutable data associated with a token.


  _createClass(Get, [{
    key: "data",
    value: function () {
      var _data = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tokenId) {
        var _yield$this$dataCids, mutableCid, immutableCid, tokenStats, mutableData, immutableData;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.dataCids(tokenId);

              case 3:
                _yield$this$dataCids = _context.sent;
                mutableCid = _yield$this$dataCids.mutableCid;
                immutableCid = _yield$this$dataCids.immutableCid;
                tokenStats = _yield$this$dataCids.tokenStats;
                _context.next = 9;
                return this.getCidData(mutableCid);

              case 9:
                mutableData = _context.sent;
                _context.next = 12;
                return this.getCidData(immutableCid);

              case 12:
                immutableData = _context.sent;
                return _context.abrupt("return", {
                  immutableData: immutableData,
                  mutableData: mutableData,
                  tokenStats: tokenStats
                });

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](0);
                console.log('Error in slp-mutable-data/get.js/data(): ', _context.t0);
                throw _context.t0;

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 16]]);
      }));

      function data(_x) {
        return _data.apply(this, arguments);
      }

      return data;
    }() // Retrieve the IPFS CIDs for both mutable and immutable data.
    // Returns an object with IPFS CIDs for mutable and immutable data.

  }, {
    key: "dataCids",
    value: function () {
      var _dataCids = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(tokenId) {
        var tokenStats, immutableCid, mutableCid;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(!tokenId || typeof tokenId !== 'string')) {
                  _context2.next = 3;
                  break;
                }

                throw new Error('tokenId string required when calling get.dataCids()');

              case 3:
                _context2.next = 5;
                return this.tokenStats(tokenId);

              case 5:
                tokenStats = _context2.sent;
                // Get the IPFS CID for the immutable data associated with this token.
                immutableCid = this.immutableCid(tokenStats);
                _context2.next = 9;
                return this.mutableCid(tokenStats);

              case 9:
                mutableCid = _context2.sent;
                return _context2.abrupt("return", {
                  mutableCid: mutableCid,
                  immutableCid: immutableCid,
                  tokenStats: tokenStats
                });

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);
                console.error('Error in slp-mutable-data/get.js/dataCids()');
                throw _context2.t0;

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 13]]);
      }));

      function dataCids(_x2) {
        return _dataCids.apply(this, arguments);
      }

      return dataCids;
    }() // Get token Genesis information and basic statistics.

  }, {
    key: "tokenStats",
    value: function () {
      var _tokenStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(tokenId) {
        var stats;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                if (!(!tokenId || typeof tokenId !== 'string')) {
                  _context3.next = 3;
                  break;
                }

                throw new Error('tokenId string required when calling get.tokenStats()');

              case 3:
                _context3.next = 5;
                return this.wallet.getTokenData(tokenId);

              case 5:
                stats = _context3.sent;
                return _context3.abrupt("return", stats.genesisData);

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);
                console.error('Error in slp-mutable-data/get.js/tokenStats()');
                throw _context3.t0;

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 9]]);
      }));

      function tokenStats(_x3) {
        return _tokenStats.apply(this, arguments);
      }

      return tokenStats;
    }() // Get IPFS CID for immutable data. Assumes input to this function is the
    // output of tokenStats()

  }, {
    key: "immutableCid",
    value: function immutableCid(tokenStats) {
      try {
        if (!tokenStats.documentUri) {
          throw new Error('No documentUri property found in tokenStats');
        } // Get the immutable data CID. Assuming that it's prefixed with ipfs://
        // as per the PS002 specification.


        var immutableCid = tokenStats.documentUri;
        immutableCid = immutableCid.substring(7);
        return immutableCid;
      } catch (err) {
        console.error('Error in slp-mutable-data/get.js/immutableCid()');
        return false;
      }
    } // Get IPFS CID for mutable data. Assumes input to this function is the
    // output of tokenStats()

  }, {
    key: "mutableCid",
    value: function () {
      var _mutableCid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(tokenStats) {
        var mutableData, jsonData, mda, transactions, mdaTxs, data, largestBlock, largestTimestamp, bestEntry, txCnt, i, tx, txid, _obj, txData, vinAddress, obj, cid, _mutableCid2;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                if (tokenStats.documentHash) {
                  _context4.next = 3;
                  break;
                }

                throw new Error('No documentHash property found in tokenStats');

              case 3:
                _context4.next = 5;
                return this.decodeOpReturn(tokenStats.documentHash);

              case 5:
                mutableData = _context4.sent;
                // console.log(`mutableData: ${JSON.stringify(mutableData, null, 2)}`)
                jsonData = JSON.parse(mutableData); // mda = mutable data address.

                mda = jsonData.mda; // Convert to a BCH address if it is an ecash address.

                if (mda.includes('ecash') || mda.includes('etoken')) {
                  mda = this.bchjs.Address.ecashtoCashAddress(mda);
                } // Gets the mda transaction history
                // const transactions = await this.bchjs.Electrumx.transactions(mda)


                _context4.next = 11;
                return this.wallet.getTransactions(mda);

              case 11:
                transactions = _context4.sent;
                // console.log(`transactions: ${JSON.stringify(transactions, null, 2)}`)
                console.log("MDA has ".concat(transactions.length, " transactions in its history."));
                mdaTxs = transactions; // console.log(`mdaTxs: ${JSON.stringify(mdaTxs, null, 2)}`)

                data = false; // These are used to filter blockchain data to find the most recent
                // update to the MDA.

                largestBlock = 700000;
                largestTimestamp = 1666107111271;
                // Used to track the number of transactions before the best candidate is found.
                txCnt = 0; // Maps each transaction of the mda.
                // If it finds an OP_RETURN, decode it and exit the loop.
                // Start with the newest TXID entry and scan the history to find the first
                // entry with an IPFS CID.
                // for (let i = mdaTxs.length - 1; i > -1; i--) {

                i = 0;

              case 19:
                if (!(i < mdaTxs.length)) {
                  _context4.next = 59;
                  break;
                }

                tx = mdaTxs[i];
                txid = tx.tx_hash;
                txCnt++;
                _context4.next = 25;
                return this.decodeOpReturn(txid);

              case 25:
                data = _context4.sent;

                if (!data) {
                  _context4.next = 56;
                  break;
                }

                _context4.prev = 27;
                // console.log('Mutable Data  : ', data)
                // Convert the OP_RETURN data to a JSON object.
                _obj = JSON.parse(data); // console.log(`slp-mutable-data obj: ${JSON.stringify(obj, null, 2)}`)
                // Keep searching if this TX does not have a cid value.

                if (_obj.cid) {
                  _context4.next = 31;
                  break;
                }

                return _context4.abrupt("continue", 56);

              case 31:
                _context4.next = 33;
                return this.wallet.getTxData([txid]);

              case 33:
                txData = _context4.sent;
                // console.log(`txData: ${JSON.stringify(txData, null, 2)}`)
                vinAddress = txData[0].vin[0].address; // console.log(`vinAddress: ${vinAddress}`)
                // Convert to a BCH address if it is an ecash address.

                if (vinAddress.includes('ecash') || vinAddress.includes('etoken')) {
                  vinAddress = this.bchjs.Address.ecashtoCashAddress(vinAddress);
                } // console.log('mda: ', mda)
                // console.log('vinAddress: ', vinAddress)
                // Skip entry if it was not made by the MDA private key.


                if (!(mda !== vinAddress)) {
                  _context4.next = 38;
                  break;
                }

                return _context4.abrupt("continue", 56);

              case 38:
                if (bestEntry) {
                  _context4.next = 44;
                  break;
                }

                bestEntry = data;
                largestBlock = tx.height;

                if (_obj.ts) {
                  largestTimestamp = _obj.ts;
                }

                _context4.next = 51;
                break;

              case 44:
                if (!(tx.height < largestBlock)) {
                  _context4.next = 46;
                  break;
                }

                return _context4.abrupt("break", 59);

              case 46:
                if (!(_obj.ts && _obj.ts < largestTimestamp)) {
                  _context4.next = 48;
                  break;
                }

                return _context4.abrupt("continue", 56);

              case 48:
                bestEntry = data;
                largestBlock = tx.height;

                if (_obj.ts) {
                  largestTimestamp = _obj.ts;
                } // console.log('new best entry: ', bestEntry)


              case 51:
                _context4.next = 56;
                break;

              case 53:
                _context4.prev = 53;
                _context4.t0 = _context4["catch"](27);
                return _context4.abrupt("continue", 56);

              case 56:
                i++;
                _context4.next = 19;
                break;

              case 59:
                console.log("".concat(txCnt, " transactions reviewed to find mutable data.")); // Get the CID:

                obj = JSON.parse(bestEntry);
                cid = obj.cid; // Dev note 10/18/22: I think this error handling line below can be
                // deleted. I don't think it's possible to get to that line in the
                // code path because of the check on line 177.
                // if (!cid) {
                //   throw new Error('CID could not be found in OP_RETURN data')
                // }
                // console.log('cid: ', cid)
                // Assuming that CID starts with ipfs://. Cutting out that prefix.

                _mutableCid2 = cid.substring(7); // console.log(`mutableCid: ${mutableCid}`)

                return _context4.abrupt("return", _mutableCid2);

              case 66:
                _context4.prev = 66;
                _context4.t1 = _context4["catch"](0);
                console.error('Error in slp-mutable-data/get.js/mutableCid()');
                return _context4.abrupt("return", false);

              case 70:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 66], [27, 53]]);
      }));

      function mutableCid(_x4) {
        return _mutableCid.apply(this, arguments);
      }

      return mutableCid;
    }() // Decodes the OP_RETURN of a transaction if this exists

  }, {
    key: "decodeOpReturn",
    value: function () {
      var _decodeOpReturn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(txid) {
        var txData, data, i, vout, script;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                if (!(!txid || typeof txid !== 'string')) {
                  _context5.next = 3;
                  break;
                }

                throw new Error('txid must be a string');

              case 3:
                _context5.next = 5;
                return this.wallet.getTxData([txid]);

              case 5:
                txData = _context5.sent;
                txData = txData[0]; // console.log(`txData: ${JSON.stringify(txData, null, 2)}`)

                data = false; // Maps the vout of the transaction in search of an OP_RETURN

                i = 0;

              case 9:
                if (!(i < txData.vout.length)) {
                  _context5.next = 18;
                  break;
                }

                vout = txData.vout[i];
                script = this.bchjs.Script.toASM(Buffer.from(vout.scriptPubKey.hex, 'hex')).split(' ');

                if (!(script[0] === 'OP_RETURN')) {
                  _context5.next = 15;
                  break;
                }

                data = Buffer.from(script[1], 'hex').toString('ascii');
                return _context5.abrupt("break", 18);

              case 15:
                i++;
                _context5.next = 9;
                break;

              case 18:
                return _context5.abrupt("return", data);

              case 21:
                _context5.prev = 21;
                _context5.t0 = _context5["catch"](0);
                console.error('Error in decodeOpReturn(): ', _context5.t0);
                throw _context5.t0;

              case 25:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 21]]);
      }));

      function decodeOpReturn(_x5) {
        return _decodeOpReturn.apply(this, arguments);
      }

      return decodeOpReturn;
    }() // Get json data from ipfs gateway

  }, {
    key: "getCidData",
    value: function () {
      var _getCidData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(cid) {
        var url, response, data;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                if (!(!cid || typeof cid !== 'string')) {
                  _context6.next = 3;
                  break;
                }

                throw new Error('cid must be a string');

              case 3:
                url = '';

                if (this.cidUrlType === 1) {
                  url = "https://".concat(this.ipfsGatewayUrl, "/ipfs/").concat(cid, "/data.json");
                } else {
                  // CID URL type 2
                  url = "https://".concat(cid, ".").concat(this.ipfsGatewayUrl, "/data.json");
                } // const url = `https://${cid}.ipfs.dweb.link/data.json`


                _context6.next = 7;
                return this.axios.get(url);

              case 7:
                response = _context6.sent;
                data = response.data;
                return _context6.abrupt("return", data);

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", {});

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 12]]);
      }));

      function getCidData(_x6) {
        return _getCidData.apply(this, arguments);
      }

      return getCidData;
    }()
  }]);

  return Get;
}();

module.exports = Get;